import React from "react";
import { MenuItem } from "../../../../types/Menu";
import { Box } from "../../../Box";
import { Flex } from "../../../Flex";
import { Icon } from "../../../Icon";
import { MenuItemLink } from "../../../MenuItemLink";

export interface MobileSubMenuHeaderProps {
  active?: boolean;
  parentItem: MenuItem;
  toggle: () => void;
  onItemClick: () => void;
}

export const MobileSubMenuHeader: React.FC<MobileSubMenuHeaderProps> = ({ active, parentItem, toggle, onItemClick }) => (
  <Box as="li" alignItems="center" mt={15} minHeight={45}>
    <Flex alignItems="center">
      <Flex alignItems="center" minHeight={45} minWidth={25} onClick={toggle} data-testid="icon">
        <Icon icon="chevron-left" fontSize={4} color="white" />
      </Flex>
      <MenuItemLink to={parentItem.url} onClick={onItemClick} fontSize={4} ml={1} color="white" fontWeight="bold">
        {parentItem.title}
      </MenuItemLink>
    </Flex>
    {active && <Box mt={2} ml={30} borderTop="1px solid" borderColor={parentItem.highlightColor} data-testid="menu-item-active" />}
  </Box>
);

MobileSubMenuHeader.defaultProps = {
  active: false,
};
